import React from 'react'
import { connect } from 'react-redux'
import Moment from 'react-moment'
import { Button } from 'reactstrap'
import { handleLoadReconProducts } from '../actions/reconciliationTypes'

const ReconTableItem = ({ index, recon, handleLoadReconProducts, selectedCompany }) => {
  return (
    <tr key={index}>
      <td>
        <Button color="link" onClick={() => handleLoadReconProducts(selectedCompany.id, recon.id)}>
          <Moment format={'MMMM YYYY'}>{recon.reconciliationMonth}</Moment>
        </Button>
      </td>
      <td style={{ verticalAlign: 'middle' }}>{recon.status}</td>
      <td style={{ verticalAlign: 'middle' }}>{recon.productCount}</td>
      <td style={{ verticalAlign: 'middle' }}>{recon.remainingCount}</td>
      <td style={{ verticalAlign: 'middle' }}>
        <Button size="sm" color="primary" onClick={() => handleLoadReconProducts(selectedCompany.id, recon.id)}>
          Edit
        </Button>
      </td>
    </tr>
  )
}

const mapDispatchToProps = {
  handleLoadReconProducts,
}

const mapStateToProps = (state) => ({
  selectedCompany: state.recon.selectedCompany,
})

export default connect(mapStateToProps, mapDispatchToProps)(ReconTableItem)
